// @flow
export const SHOW_PANEL = 'ui/SHOW_PANEL';
export const HIDE_PANEL = 'ui/HIDE_PANEL';
export const SHOW_TOAST = 'ui/SHOW_TOAST';
export const HIDE_TOAST = 'ui/HIDE_TOAST';
export const SHOW_MODAL_BOKECC = 'ui/SHOW_MODAL_BOKECC';
export const HIDE_MODAL_BOKECC = 'ui/HIDE_MODAL_BOKECC';
export const SHOW_AUTOSUGGEST = 'ui/SHOW_AUTOSUGGEST';
export const HIDE_AUTOSUGGEST = 'ui/HIDE_AUTOSUGGEST';
export const SHOW_BACK_ARROW = 'ui/SHOW_BACK_ARROW';
export const HIDE_BACK_ARROW = 'ui/HIDE_BACK_ARROW';
export const SHOW_SEARCH_BAR = 'ui/SHOW_SEARCH_BAR';
export const HIDE_SEARCH_BAR = 'ui/HIDE_SEARCH_BAR';
export const SET_TITLE_BAR = 'ui/SET_TITLE_BAR';
export const SHOW_DIALOG = 'ui/SHOW_DIALOG';
export const HIDE_DIALOG = 'ui/HIDE_DIALOG';

export function showDialog( dialog ) {
    return {
        type: SHOW_DIALOG,
        payload: dialog
    };
}

export function hideDialog() {
    return {
        type: HIDE_DIALOG,
    };
}

export function showPanel() {
    return {
        type: SHOW_PANEL,
    };
}

export function hidePanel() {
    return {
        type: HIDE_PANEL,
    };
}

export function showToast( options ) {
    return {
        type: SHOW_TOAST,
        options
    };
}

export function hideToast() {
    return {
        type: HIDE_TOAST,
    };
}

export function showModalBokecc( options ) {
    return {
        type: SHOW_MODAL_BOKECC,
        options
    };
}

export function hideModalBokecc() {
    return {
        type: HIDE_MODAL_BOKECC,
    };
}

export function showAutoSuggest() {
    return {
        type: SHOW_AUTOSUGGEST,
    };
}

export function hideAutoSuggest() {
    return {
        type: HIDE_AUTOSUGGEST,
    };
}

export function showSearchBar() {
    return {
        type: SHOW_SEARCH_BAR,
    };
}

export function hideSearchBar() {
    return {
        type: HIDE_SEARCH_BAR,
    };
}

export function showBackArrow() {
    return {
        type: SHOW_BACK_ARROW,
    }
}

export function hideBackArrow() {
    return {
        type: HIDE_BACK_ARROW,
    }
}

export function setTitleBar( titleBar ) {
    return {
        type: SET_TITLE_BAR,
        titleBar
    };
}
